import { render, staticRenderFns } from "./GenericForm.vue?vue&type=template&id=ae7ee586"
import script from "./GenericForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenericForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports